import Cookies from 'js-cookie';

export default function popup() {
  const $modal = $('#modal-popup');

  if (!$modal.length) {
    return;
  }

  const popupId = $modal.attr('data-id');
  const popupShown = sessionStorage.getItem(`popup-shown-${popupId}`);
  let closeCount = parseInt(sessionStorage.getItem(`popup-close-count-${popupId}`)) || 0;

  if (!popupShown || closeCount < 1) {
    const delay = 10000; // 10 seconds
    setTimeout(function () {
      $modal.modal();
      sessionStorage.setItem(`popup-shown-${popupId}`, 'true');
    }, delay);
  }

  function incrementCloseCount() {
    closeCount++;
    sessionStorage.setItem(`popup-close-count-${popupId}`, closeCount);
  }

  $modal.find('a, .close').click(function (e) {
    incrementCloseCount();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      incrementCloseCount();
    }
  });

  $modal.on('click', function (e) {
    if (!$(e.target).closest('.modal-content').length || $(e.target).is('a, .close')) {
      incrementCloseCount();
    }
  });



}
